module.exports = __webpack_public_path__ + "static/img/hoper.d6c9bd91.png";